import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ spacing, palette, typography, variables,schema }: Theme) => ({
    "@global": {
        '.MuiDialog-root':{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop:'-72px',
                height:'100vh'
        },
        '.MuiBackdrop-root':{
            height:'100vh'
        },
    },
    jetDialog:{
        '& .MuiDialog-paper':{
            borderRadius:variables?.radiusRoundedD,
            maxWidth:'600px',
            minHeight:'220px',
            '@media only screen and (max-height: 360px)':{
                margin:`${variables?.spacingD} !important`
            }
        },
        '& .MuiDialog-paperScrollPaper':{
            maxHeight:'unset !important'
        }
    }
}))


export default styles;